<template>
    <div class="card shadow">
        <div class="card-body">
            <FullCalendar :options="calendarOptions" />  
        </div>
    </div>
</template>
<script>
import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import prBrLocales from "@fullcalendar/core/locales/pt-br";
export default {
    props: ["eventos"],
    components: {
        FullCalendar
    },
    data() {
        return {
            calendarOptions: {
                plugins: [
                    dayGridPlugin,
                    listPlugin,
                    timeGridPlugin,
                    interactionPlugin
                ],
                initialView: "dayGridMonth",
                locales: [prBrLocales],
                locale: "pt-br",
                headerToolbar: {
                    left: "prev,next",
                    center: "title",
                    right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek"
                },
                events: this.eventos,
                editable: true,
                selectable: true,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                dateClick: this.handleDateClick,
                eventClick: this.handleEventClick,
                eventsSet: this.eventSelected,
                eventDrop: this.eventDrop,
                eventChange: this.eventChange,
                select: this.handleDateClick
            }
        };
    },
    methods: {
        handleDateClick(arg) {
            this.$emit("clicked", arg);
        },
        handleEventClick(clickInfo) {
            this.$emit("event-clicked", clickInfo);
        },
        eventSelected(clickInfo) {},
        eventDrop(event) {
            this.$emit("drop", event);
        },
        eventChange(event) {
            this.$emit("update", event);
            //console.log(event);
        }
    }
};
</script>
<style lang="css">
th.fc-col-header-cell.fc-day {
    background: #e3e3e3 !important;
}
a.fc-col-header-cell-cushion {
    color: #67686b !important;
    text-transform: capitalize !important;
}
h2.fc-toolbar-title {
    text-transform: capitalize !important;
}
</style>
